import React, { useState } from 'react';
import { FileText, Image as ImageIcon, Video, Download, X, Maximize2 } from 'lucide-react';
import './Tutorials.css'; // Shared styles

const MediaViewer = ({ file, type, title, onClose }) => {
  const [isEnlarged, setIsEnlarged] = useState(false);

  if (!file) return null;

  const handleDownload = (e) => {
    e.stopPropagation();
    const link = document.createElement('a');
    link.href = file;
    link.setAttribute('download', title || 'download');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const renderContent = () => {
    switch (type) {
      case 'PDF':
        return (
          <div className="media-viewer__pdf">
            <iframe 
              src={`${file}#toolbar=0`} 
              title={title} 
              width="100%" 
              height="100%"
              style={{ border: 'none', borderRadius: '8px' }}
            />
          </div>
        );
      
      case 'Image':
        return (
          <div className={`media-viewer__image-container ${isEnlarged ? 'media-viewer__image-container--full' : ''}`}>
             <img 
               src={file} 
               alt={title} 
               className="media-viewer__img"
               onClick={() => setIsEnlarged(!isEnlarged)} 
             />
             {!isEnlarged && (
               <button className="media-viewer__enlarge-btn" onClick={() => setIsEnlarged(true)}>
                 <Maximize2 size={20} />
               </button>
             )}
          </div>
        );

      case 'Video':
        return (
          <div className="media-viewer__video">
            <video 
              controls 
              playsInline 
              controlsList="nodownload"
              className="media-viewer__video-player"
            >
              <source src={file} />
              Your browser does not support the video tag.
            </video>
          </div>
        );

      default:
        return (
          <div className="media-viewer__unknown">
            <FileText size={48} />
            <p>Unknown file format</p>
          </div>
        );
    }
  };

  return (
    <div className="media-viewer">
      <div className="media-viewer__overlay" onClick={onClose}></div>
      <div className={`media-viewer__content ${isEnlarged ? 'media-viewer__content--expanded' : ''}`}>
        <div className="media-viewer__header">
          <div className="media-viewer__info">
            {type === 'PDF' && <FileText size={18} className="text-blue-500" />}
            {type === 'Image' && <ImageIcon size={18} className="text-green-500" />}
            {type === 'Video' && <Video size={18} className="text-purple-500" />}
            <span className="media-viewer__title">{title}</span>
          </div>
          <div className="media-viewer__actions">
            <button className="media-viewer__download" onClick={handleDownload} title="Download File">
              <Download size={18} />
              <span>Download</span>
            </button>
            <button className="media-viewer__close" onClick={onClose}>
              <X size={20} />
            </button>
          </div>
        </div>
        
        <div className="media-viewer__body">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default MediaViewer;
